export const CustomIcon = ({ name, size, color , style}: { name: string; size?: number; color?: string, style?: React.CSSProperties }) => {
    return <i className={`fi fi-br-${name}`} style={{ fontSize: size, color, ...style }} />;
};
const Icons = ({ name, size, color, style }: { name: string; size?: number; color?: string, style?: React.CSSProperties }) => {
    return <i className={`fi fi-br-${name}`} style={{ fontSize: size, color, ...style }} />;
};

export default Icons;
